import type {
	Product,
	ProductItem
} from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import type { BasketItem } from "@nwt/norce-pwa/dist/runtime/types/api/shopping/basket";
import type { FilteredProductItem } from "@nwt/norce-pwa/dist/runtime/types/api/searchAndFilter/filters";

export interface GtmItem {
	item_id?: number;
	item_name?: string;
	item_brand?: string;
	item_category?: string | number;
	price: number;
	quantity: number;
	currency: string;
}

export type GtmTrackableItem =
	| Product
	| ProductItem
	| BasketItem
	| FilteredProductItem
	| Partial<FilteredProductItem>
	| Partial<BasketItem>;

export const createGtmItem = (
	item: GtmTrackableItem,
	currency: string,
	category?: string | number,
	defaultQuantity: number = 1
): GtmItem | null => {
	if (
		!("Id" in item) ||
		item.Id == null ||
		!("Name" in item) ||
		item.Name == null
	) {
		console.warn("Item is missing Id or Name", item);
		return null;
	}

	const price =
		"PriceDisplayIncVat" in item && item.PriceDisplayIncVat != null
			? item.PriceDisplayIncVat
			: "PriceIncVat" in item && item.PriceIncVat != null
				? item.PriceIncVat
				: 0;

	const brand =
		"ManufacturerName" in item && item.ManufacturerName != null
			? item.ManufacturerName
			: "Manufacturer" in item && item.Manufacturer?.Name != null
				? item.Manufacturer.Name
				: undefined;

	const itemCategory =
		category ??
		("CategoryIdSeed" in item && item.CategoryIdSeed != null
			? item.CategoryIdSeed
			: "CategoryId" in item && item.CategoryId != null
				? item.CategoryId
				: "Type" in item && item.Type === 3
					? "Freight"
					: undefined);

	return {
		item_id: item.Id,
		item_name: item.Name,
		...(brand ? { item_brand: brand } : {}),
		...(itemCategory ? { item_category: itemCategory } : {}),
		price,
		quantity:
			"Quantity" in item && item.Quantity != null
				? item.Quantity
				: defaultQuantity,
		currency
	};
};
